module.exports = __webpack_public_path__ + "img/HN.8543709e.svg";